// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__w2VED","unreadBadge":"styles_unreadBadge__1zQSv","modalContent":"styles_modalContent__HbuU6","modal":"styles_modal__2YACy"};